import React, { useState } from 'react';
import './UserManagement.css';

const UserManagement = ({ users, onAddUser, onUpdateUser, onDeleteUser, currentUserId, onResetPassword }) => {
  const [showAddForm, setShowAddForm] = useState(false);
  const [newUser, setNewUser] = useState({
    displayName: '',
    userName: '',
    isAdmin: false
  });

  const handleAddUser = async (e) => {
    e.preventDefault();
    
    if (!newUser.displayName.trim() || !newUser.userName.trim()) {
      alert('请填写显示名称和用户名');
      return;
    }

    try {
      await onAddUser(newUser);
      setNewUser({ displayName: '', userName: '', isAdmin: false });
      setShowAddForm(false);
    } catch (error) {
      console.error('Error adding user:', error);
    }
  };

  const handleUpdateUserStatus = async (userId, isAdmin) => {
    try {
      await onUpdateUser(userId, { isAdmin });
    } catch (error) {
      console.error('Error updating user:', error);
    }
  };

  const handleDeleteUser = async (userId, userName) => {
    if (userId === currentUserId) {
      alert('不能删除当前登录的用户');
      return;
    }

    if (window.confirm(`确定要删除用户 "${userName}" 吗？此操作无法撤销。`)) {
      try {
        await onDeleteUser(userId);
      } catch (error) {
        console.error('Error deleting user:', error);
      }
    }
  };

  const handleResetPassword = async (userId, userName) => {
    if (window.confirm(`确定要重置用户 "${userName}" 的密码为 000000 吗？用户下次登录时需要修改密码。`)) {
      try {
        await onResetPassword(userId);
        alert('密码已重置为 000000');
      } catch (error) {
        console.error('Error resetting password:', error);
      }
    }
  };

  return (
    <div className="user-management-container">
      <div className="user-management-header">
        <button 
          className="add-user-button"
          onClick={() => setShowAddForm(!showAddForm)}
        >
          {showAddForm ? '取消' : '+ 添加用户'}
        </button>
      </div>

      {showAddForm && (
        <div className="add-user-form-container">
          <form onSubmit={handleAddUser} className="add-user-form">
            <div className="form-row">
              <div className="form-group">
                <label>显示名称</label>
                <input
                  type="text"
                  value={newUser.displayName}
                  onChange={(e) => setNewUser({ ...newUser, displayName: e.target.value })}
                  placeholder="例如：张三"
                  required
                />
              </div>
              <div className="form-group">
                <label>用户名（登录用）</label>
                <input
                  type="text"
                  value={newUser.userName}
                  onChange={(e) => setNewUser({ ...newUser, userName: e.target.value })}
                  placeholder="例如：zhangsan"
                  required
                />
              </div>
            </div>
            <div className="form-group">
              <label className="user-form-checkbox-label">
                <input
                  type="checkbox"
                  checked={newUser.isAdmin}
                  onChange={(e) => setNewUser({ ...newUser, isAdmin: e.target.checked })}
                />
                <span>设为管理员</span>
              </label>
            </div>
            <div className="form-actions">
              <button type="submit" className="submit-button">创建用户</button>
              <p className="form-note">默认密码：000000（用户首次登录时需要修改）</p>
            </div>
          </form>
        </div>
      )}

      <div className="users-table-container">
        <table className="users-table">
          <thead>
            <tr>
              <th>ID</th>
              <th>显示名称</th>
              <th>用户名</th>
              <th>角色</th>
              <th>创建时间</th>
              <th>操作</th>
            </tr>
          </thead>
          <tbody>
            {users.map(user => (
              <tr key={user.id} className={user.id === currentUserId ? 'current-user' : ''}>
                <td>{user.id}</td>
                <td>{user.displayName}</td>
                <td>{user.userName}</td>
                <td>
                  <select
                    value={user.isAdmin ? 'admin' : 'user'}
                    onChange={(e) => handleUpdateUserStatus(user.id, e.target.value === 'admin')}
                    className={`role-select ${user.isAdmin ? 'admin-role' : 'user-role'}`}
                    disabled={user.id === currentUserId}
                  >
                    <option value="admin">管理员</option>
                    <option value="user">普通用户</option>
                  </select>
                </td>
                <td>{new Date(user.created_at).toLocaleDateString('zh-CN')}</td>
                <td className="action-buttons">
                  <button
                    className="reset-password-button"
                    onClick={() => handleResetPassword(user.id, user.userName)}
                    title="重置密码为 000000"
                  >
                    重置密码
                  </button>
                  <button
                    className="delete-user-button"
                    onClick={() => handleDeleteUser(user.id, user.userName)}
                    disabled={user.id === currentUserId}
                    title={user.id === currentUserId ? '不能删除当前用户' : '删除用户'}
                  >
                    删除
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {users.length === 0 && (
        <div className="no-users-message">
          <p>暂无用户</p>
        </div>
      )}
    </div>
  );
};

export default UserManagement;
